var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _vm._l(_vm.items, function (v, i) {
            return _c(
              "div",
              { key: i },
              [
                _vm.isEmpty(v.id)
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: { small: "", outlined: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onClick(v.id)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(v.name) + " ")]
                    )
                  : _c(
                      "v-btn",
                      {
                        staticClass: "mx-1",
                        attrs: { small: "", color: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.onClick(v.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(v.name))]
                    ),
              ],
              1
            )
          }),
          _c("r-item-state-dialog", { ref: "r-item-state-dialog" }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }